import React from "react";
import {useFeatureFlags} from "utilities/featureUtil";
import NavigationBar from "./NavigationBar";
import AdminNavbar from "core/bars/AdminNavbar";

export default function AdminNavbarWrapper(props) {
  const flags = useFeatureFlags();

  return flags.newInbox && flags.newInboxMobile ? (
    <NavigationBar {...props} />
  ) : (
    <AdminNavbar {...props} />
  );
}
